import React from "react";

import PageStructure from "../components/ui/PageStructure";

// component for all goals page
const Home: React.FC = () => {
  return <PageStructure title="all goals" />;
};

export default Home;
